// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolsPlug_root__7zjAi","_tools-wrapper":"ToolsPlug__tools-wrapper__6XZZn","_toolbar":"ToolsPlug__toolbar___Lmkg"};